<template>
  <fieldset class="space-y-2 text-sm" :data-field="path">
    <legend class="font-medium" style="color: var(--text-secondary);">
      {{ label }}
    </legend>
    <div v-for="(entry, position) in values" :key="position" class="flex items-center gap-2">
      <input
        class="form-input grow min-w-0"
        type="text"
        :aria-label="`${label} ${position + 1}`"
        :data-field="`${path}.${position}`"
        :value="entry"
        :maxlength="maxLength"
        :disabled="readOnly"
        @input="change(position, $event.target.value)">
      <button
        v-if="!readOnly"
        type="button"
        class="btn btn-secondary btn-sm"
        :data-action="`remove-${path}.${position}`"
        :aria-label="`Remove ${label} ${position + 1}`"
        @click="remove(position)">
        Remove
      </button>
    </div>
    <button
      v-if="!readOnly && values.length < maxItems"
      type="button"
      class="btn btn-secondary btn-sm"
      :data-action="`add-${path}`"
      @click="$emit('update', [...values, ''])">
      Add a line
    </button>
  </fieldset>
</template>

<script setup>
const props = defineProps({
  label: { type: String, required: true },
  path: { type: String, required: true },
  values: { type: Array, default: () => []},
  maxItems: { type: Number, default: 20 },
  maxLength: { type: Number, default: undefined },
  readOnly: { type: Boolean, default: false }
})

const emit = defineEmits(['update'])

function change(position, value) {
  emit('update', props.values.map((entry, index) => (index === position ? value : entry)))
}

function remove(position) {
  emit('update', props.values.filter((_entry, index) => index !== position))
}
</script>
